export default __webpack_public_path__ + "static/media/MarkerIcon.4e789a15.svg";